
import { useState } from "react";
import { format } from "date-fns";
import { de } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { BirthdatePickerModal } from "./BirthdatePickerModal";

interface DatePickerFieldProps {
  id: string;
  label: string;
  value: Date | undefined;
  onChange: (date: Date | undefined) => void;
  error?: string;
  required?: boolean;
}

export const DatePickerField = ({
  id,
  label,
  value,
  onChange,
  error,
  required = false
}: DatePickerFieldProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDateSelect = (date: Date) => {
    onChange(date);
    setIsModalOpen(false);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Button
        id={id}
        variant="outline"
        type="button"
        className={cn(
          "w-full justify-start text-left font-normal",
          !value && "text-muted-foreground",
          error && "border-red-500"
        )}
        onClick={() => setIsModalOpen(true)}
      >
        <CalendarIcon className="mr-2 h-4 w-4" />
        {value ? (
          format(value, "dd. MMMM yyyy", { locale: de })
        ) : (
          <span>Geburtsdatum auswählen</span>
        )}
      </Button>
      
      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}

      <BirthdatePickerModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelect={handleDateSelect}
        currentDate={value}
      />
    </div>
  );
};
